import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { DashboardPage } from "./pages/DashboardPage";
import { HistoryPage } from "./pages/HistoryPage";
import { PreferencesPage } from "./pages/PreferencesPage";
import { PageLoading } from "./pages/DashboardPage";

const TrendsPage = lazy(() => import("./pages/TrendsPage").then((module) => ({ default: module.TrendsPage })));
const TherapiesPage = lazy(() => import("./pages/TherapiesPage").then((module) => ({ default: module.TherapiesPage })));
const TherapyReviewPage = lazy(() => import("./pages/TherapyReviewPage").then((module) => ({ default: module.TherapyReviewPage })));

export function App() {
  const { t } = useTranslation();
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/trends" element={<Suspense fallback={<PageLoading label={t("trends.loading")} />}><TrendsPage /></Suspense>} />
        <Route path="/preferences" element={<PreferencesPage />} />
        <Route path="/therapies/review" element={<Suspense fallback={<PageLoading label={t("therapy.loading")} />}><TherapyReviewPage /></Suspense>} />
        <Route path="/therapies/:id?" element={<Suspense fallback={<PageLoading label={t("therapy.loading")} />}><TherapiesPage /></Suspense>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
